const routes = [
  {
    path: "/hyperpersonalizacion/usuario-final",
    name: "hpformulariohyperpersonalizacion",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/usuario-final" }
  },
  {
    path: "/hyperpersonalizacion/administrador",
    name: "hpadministracionhyperpersonalizacion",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/administrador" }
  },
  {
    path: "/hyperpersonalizacion/aprobacion-pantalla",
    name: "hpaprobacionhyperpersonalizacion",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/aprobacion-pantalla" }
  },
  {
    path: "/hyperpersonalizacion/process",
    name: "hppantallahyperpersonalizacion",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/process" }
  },
  {
    path: "/hyperpersonalizacion/configuracion/pantalla",
    name: "hpconfiguracionhyperpersonalizacion",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/configuracion-pantalla" }
  },
  {
    path: "/hyperpersonalizacion/reporteshp",
    name: "reporteshp",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/reporteshp" }
  },
  {
    path: "/hyperpersonalizacion/configuracion/scripts",
    name: "hpscripts",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/scripts" }
  },
  {
    path: "/hyperpersonalizacion/menu/agentform/:name",
    name: "hpagentform",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/agentform"},
    meta: { requiresAuth: true, withoutPermissions: true }
  },
  {
    path: "/hyperpersonalizacion/menu/agentform/:name/:number",
    name: "hpagentform",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/agentform"},
    meta: { requiresAuth: true, withoutPermissions: true }
  },
  {
    path: "/hyperpersonalizacion/menu/userform/:name",
    name: "hpuserform",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/userform"},
    meta: { requiresAuth: true, withoutPermissions: true }
  },
  {
    path: "/hyperpersonalizacion/menu/userform/:name/:number",
    name: "hpuserform",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/userform"},
    meta: { requiresAuth: true, withoutPermissions: true }
  },
  {
    path: "/hyperpersonalizacion/configuracion/definiciones",
    name: "hpdefiniciones",
    component: () => import("@/views/Hyperpersonalizacion/BeFrameHyper"),
    props: { path: "/definiciones" }
  }
];

export default routes;
